'use client'

import Link from 'next/link'

import { getPostLink } from '@/shared/lib/post-link'
import { useI18n } from '@/shared/providers'

import styles from './view.module.css'

type PostCutProps = {
    label: string
    slug: string
}

export function PostCut({ label, slug }: PostCutProps) {
    const { i18n } = useI18n()

    const href = getPostLink({ label, slug })

    return (
        <div className={styles.readMore}>
            <Link href={href} prefetch={false}>
                {i18n.POST_READ_MORE}
            </Link>
        </div>
    )
}
